/**
 * Offline packages mark their routable screens with `playOrder` in toc.json; getTocForMobile
 * (here and the Express override) only lists nodes that carry one. Some exports (duplicated or
 * re-exported books) ship a toc.json with no playOrder at all, which leaves the shell with no
 * screens and a blank page. For such a toc the INTERACTIVE nodes are numbered in document order,
 * the same rule the comparator's capture uses (packages/comparator/src/capture.js).
 */

interface PlayOrderNode {
  type?: string;
  playOrder?: number | null;
  children?: PlayOrderNode[];
}

const INTERACTIVE_TYPE = "INTERACTIVE";

const hasPlayOrder = (node: PlayOrderNode): boolean =>
  (node.playOrder !== undefined && node.playOrder !== null) ||
  Boolean(node.children?.some(hasPlayOrder));

/**
 * `toc` as it is when any node carries a playOrder; otherwise a copy (the given tree is left
 * alone) with playOrder 1..n on its INTERACTIVE nodes in document order.
 */
export const withDerivedPlayOrder = <T extends PlayOrderNode>(toc: T): T => {
  if (!toc || hasPlayOrder(toc)) {
    return toc;
  }
  let order = 0;
  const number = (node: PlayOrderNode): PlayOrderNode => {
    const copy: PlayOrderNode = { ...node };
    if (node.type === INTERACTIVE_TYPE) {
      copy.playOrder = ++order;
    }
    if (node.children) {
      copy.children = node.children.map(number);
    }
    return copy;
  };
  const numbered = number(toc) as T;
  console.warn(
    `toc: no playOrder in toc.json; numbering its ${order} INTERACTIVE screens in document order`,
  );
  return numbered;
};
